// extracted by mini-css-extract-plugin
export default {"banner":"mfr-mCUZF_dX","lightPurple":"mfr-hAAaIthq","lightOrange":"mfr-h2xB1HpR"};